import {
  Hero,
  Values,
  About,
  Landscape,
  // NewsLetter,
  Team,
  Partners,
} from "@/components/sections/home";
import { getAllMembers } from "@/lib/data";
import { GetStaticProps } from "next";

export interface Member {
  name: string;
  thumbnail: string;
  role: string;
  group: string;
}

export const getStaticProps: GetStaticProps<{ coresMembers: Member[] }> = async () => {
  try {
    const coresMembers = await getAllMembers();
    return { props: { coresMembers } };
  } catch (error) {
    console.error("Failed to load core members:", error);
    return { props: { coresMembers: [] } };
  }
};

interface HomeProps {
  coresMembers?: Member[];
}

export const Home = ({ coresMembers = [] }: HomeProps) => {
  return (
    <>
      <Hero />
      <About />
      <Landscape />
      <Team coresMembers={coresMembers} />
      <Values />
      <Partners />
      {/* <NewsLetter /> */}
    </>
  );
};

export default Home;
// import { About } from "components/sections/about";
// import { Hero } from "components/sections/hero";
// import { PortfolioPreview } from "components/sections/portfolio-preview";
// import { Timeline } from "components/sections/timeline";
// import party from "party-js";
// import { FC } from "react";
// import { components } from "twitter-api-sdk/dist/gen/openapi-types";
// import Home from "./home";

// type IndexProps = {
//   twitterData: components["schemas"]["User"];
// };

// party.settings.respectReducedMotion = false;

// export const Index: FC<IndexProps> = () => {
//   return (
//     <>
//       <Home />
//       {/* <Hero /> */}
//       {/* <About /> */}
//       {/* <Timeline /> */}
//       {/* <PortfolioPreview /> */}
//     </>
//   );
// };

// export default Index;
// {/* <Hero url={teamImage.src}>
//   <div className="container grid grow place-content-center place-items-end">
//     <h1 className="text-center text-9xl font-extrabold tracking-widest">
//       <span className="font-londrina uppercase text-white">Apel</span>
//       <span className="font-londrina-outlined uppercase text-slate-100">team</span>
//     </h1>
//   </div>
// </Hero>
// <section className="relative overflow-hidden">
//   <div className="container my-20">
//     <p className="mx-auto max-w-prose text-center">
//       Aswan Practical Engineering Lab is a student activity in Aswan Faculty of Engineering
//       Interested in teaching students about robotics and programming through technical
//       sessions and organizing national Robotics competition every year
//     </p>
//     <div className="float-right mt-10">
//       <Link href="/about">About us →</Link>
//     </div>
//   </div>
// </section> */}

// {/* <section className="col-span-3">
//   <div className="container">
//     <h1 className="heading-xl -ml-1">Upcomming Events</h1>
//     <p className="text-center font-serif text-4xl">
//       <span className="text-6xl text-cyan-600">ARC7 PHASE2</span>
//       <br />
//       Soon
//       <br />
//       Waiting You...
//     </p>
//   </div>
// </section> */}

// {/* <section className="col-span-3">
//   <div className="container">
//     <h1 className="heading-xl -ml-1">Partners</h1>
//     <div className="grid grid-cols-3 gap-8 md:grid-cols-4 lg:grid-cols-6">
//       {partners.map((member, index) => (
//         <div key={member.name} className="group">
//           <div className="flex flex-col gap-4 overflow-hidden rounded-full">
//             // <Image
//               src={`/images/${member.thumbnail}`}
//               alt={member.name}
//               width={1}
//               height={1}
//               layout="responsive"
//               priority
//               // className="transition-transform duration-300 group-hover:scale-105"
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// </section> */}
